import React, { createContext, ReactNode, useContext, useState } from 'react'

import { ProviderLoader } from './ProviderLoader'

interface ProviderLoaderContextType {
    isLoading: boolean
    showLoader: (title?: string, message?: string) => void
    hideLoader: () => void
}

const ProviderLoaderContext = createContext<
    ProviderLoaderContextType | undefined
>(undefined)

export const ProviderLoaderProvider: React.FC<{ children: ReactNode }> = ({
    children
}) => {
    const [isLoading, setIsLoading] = useState(false)
    const [loaderTitle, setLoaderTitle] = useState<string | undefined>(
        undefined
    )
    const [loaderMessage, setLoaderMessage] = useState<string | undefined>(
        undefined
    )

    const showLoader = (title?: string, message?: string): void => {
        setLoaderTitle(title)
        setLoaderMessage(message)
        setIsLoading(true)
    }
    const hideLoader = (): void => {
        setIsLoading(false)
        // Limpiar mensajes después de un pequeño delay para permitir la animación de salida
        setTimeout(() => {
            setLoaderTitle(undefined)
            setLoaderMessage(undefined)
        }, 300)
    }

    return (
        <ProviderLoaderContext.Provider
            value={{ isLoading, showLoader, hideLoader }}
        >
            <ProviderLoader
                isLoading={isLoading}
                title={loaderTitle}
                message={loaderMessage}
            />
            {children}
        </ProviderLoaderContext.Provider>
    )
}

export const useProviderLoader = (): ProviderLoaderContextType => {
    const context = useContext(ProviderLoaderContext)

    if (context === undefined) {
        throw new Error(
            'useProviderLoader must be used within a ProviderLoaderProvider'
        )
    }

    return context
}
